import { defineStore } from 'pinia';
import { ref } from 'vue';
import { api } from '@/composables/useApi';

export interface CatalogItem { id: string; name?: string; [k: string]: unknown; }

/**
 * Catalog store — holds the federation reference data (seasons,
 * competitions, teams, referees, users). Each collection is fetched
 * lazily on first access and refreshed on demand.
 */
export const useCatalogStore = defineStore('catalog', () => {
    const seasons      = ref<CatalogItem[]>([]);
    const competitions = ref<CatalogItem[]>([]);
    const teams        = ref<CatalogItem[]>([]);
    const referees     = ref<CatalogItem[]>([]);
    const users        = ref<CatalogItem[]>([]);

    async function fetchKey(key: 'seasons' | 'competitions' | 'teams' | 'referees' | 'users') {
        const data = await api<CatalogItem[]>('/' + key);
        const ref = { seasons, competitions, teams, referees, users }[key];
        ref.value = data;
    }

    async function fetchAll() {
        await Promise.all([
            fetchKey('seasons'),
            fetchKey('competitions'),
            fetchKey('teams'),
            fetchKey('referees'),
            fetchKey('users')
        ]);
    }

    return { seasons, competitions, teams, referees, users, fetchKey, fetchAll };
});
